export default {
    name: "date_add",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'Diff between %1and%2 (%3)',
                "args0": [
                    {
                        "type": "input_value",
                        "name": "DATE1",
                        "check": "Number"
                    },
                    {
                        "type": "input_value",
                        "name": "DATE2"
                    },
                    {
                        "type": "field_dropdown",
                        "name": "GRANULARITY",
                        "options": [
                            ["days", "DAYS"],
                            ["weeks", "WEEKS"],
                            ["months", "MONTHS"],
                            ["years", "YEARS"]
                        ]
                    },
                ],
                "inputsInline": true,
                "output": "Number",
                "colour": 4.5,
                "tooltip": "Difference between two dates",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {

        const javaChronoUnit = `java.time.temporal.ChronoUnit`
        const date1 = blocklyInstance.JavaScript.valueToCode(block, "DATE1", blocklyInstance.JavaScript.ORDER_ATOMIC);
        const date2 = blocklyInstance.JavaScript.valueToCode(block, "DATE2", blocklyInstance.JavaScript.ORDER_ATOMIC);
        const granularity = block.getFieldValue("GRANULARITY");
        return [`Java.type("${javaChronoUnit}").${granularity}.between(${date1}, ${date2})`, blocklyInstance.JavaScript.ORDER_NONE];
    }
}
